<div class="view-image">

	<canvas #canvas></canvas>
	<canvas #originalCanvas class="d-none"></canvas>

	<div *ngIf="showSavingLoader" class="saving-image-loader p-3">
		<span>Afbeelding opslaan</span>
	</div>

	<div class="image-drawing-options">

		<div class="image-action">
			<img src="assets/images/back.png" alt="" (click)="cancelEdit()">
		</div>
		<div class="image-action save-image" *ngIf="!showSavingLoader">
			<img src="assets/images/ok.png" (click)="saveImage()">
		</div>
		
		<div class="image-action">
			<div class="img-settings" *ngIf="imgOptions">
				<div class="tools-custom" (clickOutside)="closeOptions($event)">
					<div class="row">
						<div class="color black ng-star-inserted" ng-reflect-ng-class="black" title="Black"
							style="background: rgb(0, 0, 0);" (click)="selectColor('black')">
						</div>
						<div class="color white ng-star-inserted" title="White" style="background: rgb(255, 255, 255);"
							(click)="selectColor('white')"></div>
						<div class="color red ng-star-inserted" title="Red" style="background: rgb(244, 67, 54);"
							(click)="selectColor('red')"></div>
					</div>
				</div>
			</div>
			<img class="showImageOptions" src="assets/images/image_dots.png" (click)="imgOptions = !imgOptions">
		</div>
	</div>
</div>